<template>
  <div>
    <filter-event :range="range" v-model="event"/>
    <filter-checkboxes v-model="selected" :options="options" :enableCount="false"/>
    <label class="mt-1 mb-0">Причина неисправности</label>
    <v-multiselect
      v-model="reason"
      :options="stopReasons"
      :searchable="true"
      :internal-search="true"
      track-by="value"
      label="label"
      multiple
      placeholder=""
    >
      <template slot="option" slot-scope="props">
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ props.option.label }}</span>
        </div>
      </template>
    </v-multiselect>
  </div>
</template>

<script>
  import { omitBy, isEmpty, isEqual } from 'lodash'
  import FilterSearch from './filter-search'
  import defects from '../lang/defects.json'

  export default {
    components: {FilterSearch},
    props: {
      range: {type: Object},
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
      options: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        event: {
          number: this.value.number || {},
          date: this.value.date || {}
        },
        selected: this.value.valueCheckbox || [],
        reason: this.prepareReason(this.value.valueSearch || []),
      }
    },
    computed: {
      preparedInput () {
        return omitBy({
          number: this.event.number,
          date: this.event.date,
          valueCheckbox: this.selected,
          valueSearch: this.reason.map((o) => o['value']),
        }, isEmpty)
      },
      stopReasons () {
        return Object.entries(defects).map(([key, value]) => {
          return {
            label: value,
            value: key,
          }
        })
      },
    },
    methods: {
      prepareReason (value) {
        return value.map((v) => {
          return {label: defects[v], value: v}
        })
      }
    },
    watch: {
      value (input) {
        this.event = {
          number: input.number || {},
          date: input.date || {}
        }
        this.selected = input.valueCheckbox || []
      },
      preparedInput: {
        handler (newVal, oldVal) {
          if (!isEqual(newVal, oldVal)) {
            this.$emit('input', this.preparedInput)
          }
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-stop-defect.vue